import { FORMATS } from '@sonar-software/sonar-ts-constants';
import { getClosestCardHeader } from '@lib/popups';
import { DatePicker, Skeleton } from 'antd';
import dayjs from 'dayjs';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
export var DateRangePickerTypes;
(function (DateRangePickerTypes) {
    DateRangePickerTypes["Date"] = "date";
    DateRangePickerTypes["Week"] = "week";
    DateRangePickerTypes["Month"] = "month";
})(DateRangePickerTypes || (DateRangePickerTypes = {}));
export const DateRangePicker = ({ disabled, endDate, getPopupContainer, historyLimit, loading, maxDate, minDate, onChange, pickerType, startDate }) => {
    const originalStart = dayjs(startDate || Date.now());
    const originalEnd = dayjs(endDate || Date.now());
    const [dateRange, setDateRange] = useState([originalStart, originalEnd]);
    useEffect(() => {
        if (pickerType === DateRangePickerTypes.Week) {
            let [start, end] = dateRange;
            start = dayjs(start).startOf('week');
            end = dayjs(end).endOf('week');
            setDateRange([start, end]);
        }
    }, [pickerType]);
    const startDateLimit = useMemo(() => (historyLimit ? dayjs().startOf('day')
        .subtract(historyLimit, 'day') : null), [historyLimit]);
    const handleIsDateDisabled = useCallback((currentDate) => currentDate < (startDateLimit !== null && startDateLimit !== void 0 ? startDateLimit : 0), [startDateLimit]);
    const handleDateChange = useCallback((dates) => {
        let [start, end] = dates;
        if (!start.isSame(originalStart) || !end.isSame(originalEnd)) {
            if (pickerType === DateRangePickerTypes.Week) {
                start = dayjs(start).startOf('week');
                end = dayjs(end).endOf('week');
            }
            onChange({
                end: end.format(FORMATS.SHORT_DATE),
                start: start.format(FORMATS.SHORT_DATE)
            });
            setDateRange([start, end]);
        }
    }, [onChange, originalEnd, originalStart, pickerType]);
    if (loading) {
        return React.createElement(Skeleton, null);
    }
    return (React.createElement(DatePicker.RangePicker, { allowClear: false, disabled: disabled, disabledDate: handleIsDateDisabled, format: pickerType === DateRangePickerTypes.Week ? 'YYYY-MM-DD' : undefined, getPopupContainer: getPopupContainer !== null && getPopupContainer !== void 0 ? getPopupContainer : getClosestCardHeader, maxDate: maxDate, minDate: minDate, onChange: handleDateChange, picker: pickerType, showTime: false, value: dateRange }));
};
